<template>
  <div class="umdb-setlist">
    <b-table
      :items="items"
      :fields="fields"
      :tbody-tr-class="rowClass"
      sort-by="releaseDate"
      sort-null-last
      responsive
      class="compact-table-sm"
    >
      <template v-slot:cell(name)="data">
        <div>
          {{ data.value }}
          <span v-if="data.item.bggLink" class="small"
            >(<a :href="data.item.bggLink" target="_blank">BGG</a>)</span
          >
        </div>
        <b-img-lazy
          :src="data.item.image"
          blank-color="#7777"
          fluid
          width="200"
          height="200"
          v-if="data.item.image"
        />
      </template>

      <template v-slot:cell(releaseDate)="data">
        <span v-if="data.value">
          {{ formatDate(data.value, "MMMM YYYY") }}
          <span class="small text-muted" v-if="!data.item.released"
            >(Expected)</span
          >
        </span>
        <span v-else> Unknown </span>
      </template>

      <template v-slot:cell(decks)="row">
        <div v-for="deck in row.item.decks" :key="deck.slug">
          <router-link :to="{ name: 'UmDbDeck', params: { slug: deck.slug } }">
            {{ deck.name }}
          </router-link>
        </div>
      </template>

      <template v-slot:cell(boards)="row">
        <div v-for="board in row.item.boards" :key="board.slug">
          {{ board.name }}
        </div>
      </template>

      <template v-slot:row-details="row">
        <div
          v-if="row.item.notes"
          class="mx-4"
          v-html="parseMarkdown(row.item.notes)"
        ></div>
      </template>
    </b-table>
  </div>
</template>

<script>
import markdown from "@/mixins/markdown";
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "UmDbSetList",
  mixins: [markdown, dateFormat],
  data() {
    return {
      fields: [
        {
          key: "name",
          sortable: true,
        },
        {
          key: "decks",
          sortable: false,
        },
        {
          key: "boards",
          sortable: false,
        },
        {
          key: "releaseDate",
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => {
            return value ? new Date(value) : null;
          },
        },
      ],
    };
  },
  props: {
    sets: {
      type: Array,
      required: true,
    },
  },
  computed: {
    items() {
      return this.sets.map((set) => ({ ...set, _showDetails: !!set.notes }));
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (!item.released) return "unreleased";
    },
  },
};
</script>

<style lang="less">
.umdb-setlist {
  .unreleased {
    font-style: italic;
  }
}
</style>
